import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	IDSTATUS_REQUEST,
	IDSTATUS_CREATE,
	IDSTATUS_DELETE,
	IDSTATUS_EDIT,
	IDSTATUS_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const IDStatus = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchIdStatus,
	submitIdStatusCreate,
	submitIdStatusDelete,
	submitIdStatusEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteIdStatusId, setDeleteIdStatusId] = useState('');
	const [editIdStatusId, setEditIdStatusId] = useState('');
	const [editIdStatusName, setEditIdStatusName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchIdStatus(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("IdStatus Created Successfully.");
			fetchIdStatus(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("IdStatus Deleted Successfully.");
			fetchIdStatus(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("IdStatus Data Updated Successfully.");
			fetchIdStatus(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("IdStatus name cannot be empty.");
		} else {
			submitIdStatusCreate({
				"data": {
					"IdStatus": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteIdStatusId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteIdStatusId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitIdStatusDelete({
			"StatusId": deleteIdStatusId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditIdStatusId(data.statusId);
		setEditIdStatusName(data.idStatus);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editIdStatusName === '') {
			toast.error("IdStatus name cannot be empty.");
		} else {
			submitIdStatusEdit({
				"data": {
					"StatusId": data.statusId,
					"IdStatus": editIdStatusName,
				},
				"token": auth[0].token
			});
			setEditIdStatusId('');
			setEditIdStatusName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">

					<div className="sub-header mt-5 mb-3">
						<h2>IdStatus</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`IdStatus`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>IdStatus</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editIdStatusId === item.statusId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editIdStatusName} onChange={(evt) => setEditIdStatusName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.idStatus}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`IdStatus`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.statusId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchIdStatus: (token) => dispatch({ type: IDSTATUS_REQUEST, token }),
		submitIdStatusCreate: (data) => dispatch({ type: IDSTATUS_CREATE, payload: data }),
		submitIdStatusDelete: (data) => dispatch({ type: IDSTATUS_DELETE, payload: data }),
		submitIdStatusEdit: (data) => dispatch({ type: IDSTATUS_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: IDSTATUS_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(IDStatus);